import { ApiConfig } from 'angular-odata';
import { environment } from 'src/environments/environment';

export const ODATA_CONFIGS: ApiConfig[] = [
  { name: 'public', serviceRootUrl: `${environment.resourceApiUrl}/odata` },
  { name: 'private', serviceRootUrl: `${environment.resourceApiUrl}/me/odata` }
];
